import { GameRoomState } from "@presidents/game-engine";
import React, { useContext, useEffect, useRef } from "react";

export const GameRoomStateContext = React.createContext<GameRoomState | null>(
  null
);

export const useGameRoomState = () => useContext(GameRoomStateContext);

export const useGameState = () => {
  const roomState = useGameRoomState();
  return roomState?.currentGame?.state;
};

export const useMyHand = () => {
  const state = useGameState();
  return state?.myHand;
};

type GameRoomStateChangeCallback = (
  currRoomState: GameRoomState | null,
  nextRoomState: GameRoomState | null
) => void;
export const useGameRoomStateChange = (cb: GameRoomStateChangeCallback) => {
  const roomState = useGameRoomState();
  const currRoomStateRef = useRef(roomState);

  const callbackRef = useRef(cb);
  useEffect(() => {
    callbackRef.current = cb;
  }, [cb]);

  useEffect(() => {
    callbackRef.current?.(currRoomStateRef.current, roomState);
    currRoomStateRef.current = roomState;
  }, [roomState?._id]);
};
